import { createAsyncThunk } from "@reduxjs/toolkit";

import { getQuickPoll, setQuickPoll } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchQuickPoll = createAsyncThunk(
  "quickPoll/fetchQuickPoll",
  async (
    params: Partial<{ projectId: string; quickPollId: string; config: any }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;

    const { baseUrl } = adapter.adapter;
    const { projectId, quickPollId, config } = params;
    const { token } = fetchAuthToken(getState());
    try {
      const response = await getQuickPoll(
        token,
        baseUrl,
        projectId,
        quickPollId,
        config
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const saveQuickPoll = createAsyncThunk(
  "quickPoll/saveQuickPoll",
  async (
    params: Partial<{ projectId: string; quickPollId: string }>,
    { rejectWithValue, getState }
  ) => {
    const { quickPoll, adapter } = getState() as AppState;

    const { baseUrl } = adapter.adapter;
    const { projectId, quickPollId } = params;
    const { token } = fetchAuthToken(getState());

    try {
      const response = await setQuickPoll(
        token,
        baseUrl,
        projectId,
        quickPollId,
        quickPoll?.answer
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
